import { Link } from "react-router-dom";

interface EmptyStateProps {
  message: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function EmptyState({
  message,
  actionLabel,
  actionTo,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4">
      <span className="w-16 h-16 rounded-full bg-background-100 flex items-center justify-center mb-4">
        <i className="ri-inbox-line text-3xl text-foreground-400" />
      </span>
      <p className="text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
        {message}
      </p>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="mt-5 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {actionLabel}
        </Link>
      )}
    </div>
  );
}